// Profile API calls: who am I, update names, change password.
import { http } from "../http";

export const getMe = () => http.get(`/me`).then((r) => r.data);

export const updateProfile = ({ firstName, lastName }) =>
  http
    .put(`/me`, { first_name: firstName, last_name: lastName })
    .then((r) => r.data);

export const changePassword = ({ currentPassword, newPassword }) =>
  http
    .post(`/me/password`, {
      current_password: currentPassword,
      new_password: newPassword,
    })
    .then((r) => r.data);
